import { ListItemIcon, ListItemText, MenuItem } from '@mui/material'
import { BarChartOutlined } from '@mui/icons-material'
import { ButtonLink } from '../../../../components/wrappers/Button'
import { TtoggleDrawerOnMobile } from '../../../../containers/Sidebar/Sidebar'
import { useIntl } from 'react-intl'

interface MenuUsageStatsProps {
  pathname: string
  nested?: string
  toggleDrawerOnMobile: TtoggleDrawerOnMobile
}

export const MenuUsageStats = ({
  pathname,
  nested,
  toggleDrawerOnMobile,
}: MenuUsageStatsProps) => {
  const { formatMessage } = useIntl()
  return (
    <div onClick={toggleDrawerOnMobile}>
      <MenuItem
        className={nested}
        component={ButtonLink}
        href="/live-chat/usage-stats"
        selected={pathname.startsWith('/live-chat/usage-stats')}
      >
        <ListItemIcon>
          <BarChartOutlined />
        </ListItemIcon>
        <ListItemText
          primary={formatMessage({
            id: 'liveChat.sidebar.usageStats',
          })}
        />
      </MenuItem>
    </div>
  )
}
